import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBTextField, DBIntField, DBCheckBox, RedoButton, StatusGood } from '_components';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';
import { OtherDBDropDown } from './OtherDBDropDown';


class AlOtherRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLOTHER', 'XLOE', this.props.other.XLOENO);
        if (this.props.code === '97150') {
            this.props.clearAlGroup(this.props.noteId);
        }
    }

    componentDidUpdate() {
        if (this.props.other.XLOEPENDING === null && !this.props.trtValid) {
            this.props.updateBitField(this.props.noteId, 'MLOTHER', 'XLOENO', this.props.other.XLOENO, 'XLOEPENDING', true);
        } else if (this.props.other.XLOEPENDING === true && this.props.trtValid) {
            this.props.clearField(this.props.noteId, 'MLOTHER', 'XLOENO', this.props.other.XLOENO, 'XLOEPENDING');
        }
    }

    handleChange(event) {
        if (event.target.value === "-1" || parseInt(event.target.value) !== this.props.other.XLOEOENO) {
            this.props.clearField(this.props.noteId, 'MLOTHER', 'XLOENO', this.props.other.XLOENO, 'XLOEPENDING');
        }
        if ((event.target.value === "-1" || parseInt(event.target.value) !== this.props.other.XLOEOENO) && this.props.code === '97150') {
            this.props.clearAlGroup(this.props.noteId);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }

        if (event.target.value === "-1" || parseInt(event.target.value) === this.props.groupId) {
            this.props.clearField(this.props.noteId, 'MLOTHER', 'XLOENO', this.props.other.XLOENO, 'XLOEACTIVITY');
        }




    }

    confirmPending() {
        this.props.updateBitField(this.props.noteId, 'MLOTHER', 'XLOENO', this.props.other.XLOENO, 'XLOEPENDING', false);
    }

    handlePerformed(val) {
        if (val && !this.props.onPlan && this.props.other.XLOEOENO) {
            this.props.addPlanSubCat(this.props.noteId, this.props.plno, undefined, undefined, this.props.other.XLOEOENO);
        }
        if (!val && this.props.code === '97150') {
            this.props.clearAlGroup(this.props.noteId);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    handleTimeChange() {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.other.XLOEPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <OtherDBDropDown
                            field='XLOEOENO'
                            noteId={this.props.noteId}
                            entity='MLOTHER'
                            entityKeyColumn='XLOENO'
                            entityKeyValue={this.props.other.XLOENO}
                            className={this.props.other.XLOEPERFORMED && !this.props.other.XLOEOENO ? styles.col1_performed : styles.col1}
                            customOptions={this.props.activities}
                            onChange={(event) => this.handleChange(event)}
                        />
                    </div>

                    {this.props.code !== '97150' &&
                        <div className={styles.cell_wrapper}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='MLOTHER'
                                entityKeyColumn='XLOENO'
                                entityKeyValue={this.props.other.XLOENO}
                                field='XLOEACTIVITY'
                                className={this.props.other.XLOEPERFORMED && !this.props.other.XLOEACTIVITY ? styles.col2_wide_performed : styles.col2_wide}
                            />
                        </div>
                    }
                    {this.props.code === '97150' &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col2_wide_empty} />
                        </div>
                    }
                    <div className={styles.cell_wrapper}>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='MLOTHER'
                            entityKeyColumn='XLOENO'
                            entityKeyValue={this.props.other.XLOENO}
                            field='XLOETIME'
                            min={0}
                            className={this.props.other.XLOEPERFORMED && !this.props.other.XLOETIME ? styles.col3_narrow_performed : styles.col3_narrow}
                            onClick={() => this.handleTimeChange()}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLOTHER'
                            entityKeyColumn='XLOENO'
                            entityKeyValue={this.props.other.XLOENO}
                            field='XLOEPERFORMED'
                            className={styles.col4}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    {this.props.assistVisible &&
                        <div className={styles.cell_wrapper}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='MLOTHER'
                                entityKeyColumn='XLOENO'
                                entityKeyValue={this.props.other.XLOENO}
                                field='XLOEASSIST'
                                className={styles.col5}
                            />
                        </div>
                    }
                    {!this.props.assistVisible &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col5} />
                        </div>
                    }
                    {this.props.prevVisit &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col6}>
                                <RedoButton size='extra-small' title='Performed during previous visit' />
                            </span>
                        </div>
                    }
                </div>
                {this.props.other.XLOEPENDING &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        addPlanSubCat: bindActionCreators(noteActions.addPlanSubCat, dispatch),
        clearAlGroup: bindActionCreators(noteActions.clearAlGroup, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let other = state.entities.notes.MLOTHER[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLOTHERPREV)
        .find(key => (state.entities.notes.MLOTHERPREV[key].NoteId === noteId &&
            state.entities.notes.MLOTHERPREV[key].XLOEOENO === other.XLOEOENO &&
            state.entities.notes.MLOTHERPREV[key].XLOEACTIVITY === other.XLOEACTIVITY
        )) !== undefined ? true : false;
    let code = undefined;
    let onPlan = false;
    let assistVisible = state.entities.admissions[epno].contractTracksAssistant;
    let trtValid = true;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));


    if (other.XLOEOENO !== null) {
        code = state.entities.masterData.MLMASTEROTHER[
            Object.keys(state.entities.masterData.MLMASTEROTHER)
                .find(key => (state.entities.masterData.MLMASTEROTHER[key].OENO === other.XLOEOENO))
        ].OECODE;
        trtValid = codeValidForAdmit(epno, code);

        onPlan =
            (
                state.entities.notes.PTPLANUNTIMEDOTHER && Object.keys(state.entities.notes.PTPLANUNTIMEDOTHER)
                    .find(key => (state.entities.notes.PTPLANUNTIMEDOTHER[key].UOPLNO === plno &&
                        state.entities.notes.PTPLANUNTIMEDOTHER[key].UOOENO === other.XLOEOENO)) ? true : false
            );
    }

    let activities = state.entities.masterData.MLMASTEROTHER ?
        Object.keys(state.entities.masterData.MLMASTEROTHER)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTEROTHER[key].OEPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTEROTHER[key].OEMC) ||
                    (isWc && state.entities.masterData.MLMASTEROTHER[key].OEWC) ||
                    (isAuto && state.entities.masterData.MLMASTEROTHER[key].OEAUTO) ||
                    (isOther && state.entities.masterData.MLMASTEROTHER[key].OEOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTEROTHER[a].OENAME - state.entities.masterData.MLMASTEROTHER[b].OENAME)
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTEROTHER[key].OENO,
                    value: state.entities.masterData.MLMASTEROTHER[key].OENAME + ' - ' + state.entities.masterData.MLMASTEROTHER[key].OECODE
                }
            )) : [];
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    let groupId = parseInt(Object.keys(state.entities.masterData.MLMASTEROTHER)
        .find(key => (state.entities.masterData.MLMASTEROTHER[key].OECODE === '97150')));

    return {
        noteId: noteId,
        xlno: xlno,
        other: other,
        activities: activities,
        trtValid: trtValid,
        prevVisit: prevVisit,
        assistVisible: assistVisible,
        plno,
        onPlan,
        code,
        computedChargesVisible,
        performedDisabled,
        groupId
    };
}

const connectedAlOtherRow = connect(mapStateToProps, mapDispatchToProps)(AlOtherRow);
export { connectedAlOtherRow as AlOtherRow };

